export default __webpack_public_path__ + "static/media/app-store.f87d85a1.svg";